<template>
  <div class="production">
    <!-- ---头部--- -->
    <content-title title="生产设施表" />
    <div class="add-btn" v-if="editOrView == 'edit'">
      <Button v-if="reportType === 'year'" type="primary" class="btn-c-common mg-l-10" @click="exportReport" :loading="btnLoading.exportReport">导出</Button>
    </div>
    <!-- ---table显示区域--- -->
     <Tabs :value="activeUnitName" @on-click="tabsClick">
            <TabPane v-for="(item,index) in resData" :key="index" :label="item.unitName" :name="item.unitName"/>
      </Tabs>
    <Table class="small-table" border :span-method="SpanCellMerge" :disabled-hover="true" :columns="columns" :data="data" :loading="tableLoading" />
    <!-- ---next--- -->
    <div v-if="editOrView == 'edit'" class="btn">
      <Button class="btn-c-common" type="primary" @click="nextPage">下一步</Button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import contentTitle from "@/components/comment/content-title.vue";

import { reportProductList } from "@/api/emissions-report";

import { exportProductionFacilities } from '@/api/file'
export default {
  name: "production",
  components: {
    contentTitle,
  },
  data () {
    return {
      tableLoading: false,
      // 合并行/列
      merge1: [],
      pos1: 0,
      columns: [
        {
          title: "机组名称",
          key: "unitName",
          align: "center",
        },
        {
          title: "生产设施类别",
          align: "center",
          key: "productType",
        },
        {
          title: '生产设施编号',
          align: 'center',
          key: 'productCode',
          render: (h, params) => {
            return h("span", {}, params.row.productCode[0]);
          },
        },
        {
          title: '生产设施名称',
          align: 'center',
          key: 'productName'
        },
        {
          title: "数据名称",
          align: "center",
          key: "infoItem",
          render: (h, params) => {
            let msgArr = [];
            for (let i = 0; i < params.row.infoItem.length - 1; i++) {
              let tempArr = h("tr", {}, [
                h(
                  "td",
                  {
                    style: {
                      "text-align": "center",
                      "border-right": "none",
                    },
                  },
                  params.row.infoItem[i]
                ),
              ]);
              msgArr.push(tempArr);
            }
            let newData = h("tr", {}, [
              h(
                "td",
                {
                  style: {
                    "text-align": "center",
                    "border-right": "none",
                    "border-bottom": "none",
                  },
                },
                params.row.infoItem[params.row.infoItem.length - 1]
              ),
            ]);
            msgArr.push(newData);
            return h(
              "table",
              {
                style: {
                  width: "100%",
                },
              },
              msgArr
            );
          },
        },
        {
          title: "数据值",
          key: "infoValue",
          align: "center",
          render: (h, params) => {
            let msgArr = [];
            for (let i = 0; i < params.row.infoValue.length - 1; i++) {
              let tempArr = h("tr", {}, [
                h(
                  "td",
                  {
                    style: {
                      "text-align": "center",
                      "border-right": "none",
                    },
                  },
                  params.row.infoValue[i]
                ),
              ]);
              msgArr.push(tempArr);
            }
            let newData = h("tr", {}, [
              h(
                "td",
                {
                  style: {
                    "text-align": "center",
                    "border-right": "none",
                    "border-bottom": "none",
                  },
                },
                params.row.infoValue[params.row.infoValue.length - 1]
              ),
            ]);
            msgArr.push(newData);
            return h(
              "table",
              {
                style: {
                  width: "100%",
                },
              },
              msgArr
            );
          },
        },
        {
          title: "备注",
          key: "remark",
          align: "center",
        },
      ],
      data: [],
      activeUnitName: '',
      resData: {}, // 返回数据， 用于请求接口时作为参数编辑
      btnLoading: {
          exportReport: false
      },
    };
  },
  created () {
    this.getList();
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    reportId () {
      return this.getUserInfo.user.reportId;
    },
    companyId () {
      return this.getUserInfo.user.companyId;
    },
    editOrView () {
      return this.getUserInfo.user.editOrView;
    },
    reportType() {
      return this.getUserInfo.user.reportType;
    },
  },
  methods: {
    classify(arr){
          let map = {};
          let myArr = [];
          for(let i = 0; i < arr.length; i++){
            if(!map[arr[i].unitName]){
              myArr.push({
                unitName: arr[i].unitName,
                data: [arr[i]]
              });
              map[arr[i].unitName] = arr[i]
            } else {
              for(let j = 0; j < myArr.length; j++){
                if(arr[i].unitName === myArr[j].unitName){
                  myArr[j].data.push(arr[i]);
                  break
                }
              }
            }
          }
          return myArr
        },
    getResData(data){
            let tempData = this.classify(data)
            this.resData = tempData
            if(this.activeUnitName) {
                let activeData = this.resData.filter(item=>{
                    return item.unitName === this.activeUnitName
                })
                this.data = activeData[0].data
            } else {
                this.data = tempData[0].data
                this.activeUnitName = tempData[0].unitName
            }
    },
    tabsClick(name) {
            this.activeUnitName = name
            this.data = []
            let tempData = this.resData.filter(item=>{
                return item.unitName === name
            })
            this.data = JSON.parse(JSON.stringify(tempData[0].data))
    },
    async getList () {
      this.tableLoading = true;
      let params = {
        reportId: this.reportId,
        companyId: this.companyId,
      };
      const { body } = await reportProductList(params)
      if (body === '该企业还未提交质量控制计划') {
        this.$Message.error(body)
      } else {
        let tempData = body
        tempData.map((item) => {
          item.unitName = item.unitName[0];
          item.productType = item.productType[0];
          item.productName = item.productName[0] === 'null' ? '' : item.productName[0];
          item.remark = item.remark[0];
        });
        this.getSpanArr(tempData, "unitName");
        this.getResData(tempData)
      }
      this.tableLoading = false;
    },
    // 合并列表
    getSpanArr (data, key1, key2) {
      let num = 0;
      if (key2 == undefined) {
        num = 1;
      } else {
        num = 2;
      }
      this[`merge${num}`] = [];
      this[`pos${num}`] = "";
      for (let i = 0; i < data.length; i++) {
        if (i === 0) {
          this[`merge${num}`].push(1);
          this[`pos${num}`] = 0;
        } else {
          // 判断当前元素与上一个元素是否相同
          //根据相同key进行合并,根据需要可进行修改
          let temp;
          if (key2 != undefined) {
            temp = data[i][key2] === data[i - 1][key2] && data[i][key1] === data[i - 1][key1];
          }
          if (key2 == undefined) {
            temp = data[i][key1] === data[i - 1][key1];
          }
          if (temp) {
            this[`merge${num}`][this[`pos${num}`]] += 1;
            this[`merge${num}`].push(0);
          } else {
            this[`merge${num}`].push(1);
            this[`pos${num}`] = i;
          }
        }
      }
    },
    SpanCellMerge ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.merge1[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    nextPage () {
      this.$router.push({ path: "/report/report2-6" });
    },
    exportReport(){
            this.btnLoading.exportReport = true
            let params = { reportId: this.reportId };
            exportProductionFacilities(params).then(res=>{
                let headers = res.headers
                const fileName = decodeURI(headers["content-disposition"].split("filename=")[1]).replace(/\"/g, "");
                const content = res.data;
                const blob = new Blob([content]);
                if ("download" in document.createElement("a")) {
                  // 非IE下载
                  const elink = document.createElement("a");
                  elink.download = fileName;
                  elink.style.display = "none";
                  elink.href = URL.createObjectURL(blob);
                  document.body.appendChild(elink);
                  elink.click();
                  URL.revokeObjectURL(elink.href); // 释放URL 对象
                  document.body.removeChild(elink);
                } else {
                  // IE10+下载
                  navigator.msSaveBlob(blob, fileName);
                }
                this.btnLoading.exportReport = false
            })
        },
  },
};
</script>

<style lang="less" scoped>
.btn {
  width: 80px;
  margin: 46px auto 0;
}
</style>
